import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { InventoryItemRecord } from "./InventoryItemRecord"
import data from "../../../../assets/apiRoutes.json";
import axios from "axios";
import { connect } from "react-redux";
import { useHistory } from 'react-router-dom';
import InventorySubLotGrid from "./InventorySubLotGrid";
import LocationsPopUp from "./LocationsPopUp";
import InventoryItemStatusPopUp from "./InventoryItemStatusPopUp";
import InventorySerialNamberPopUp from "./InventorySerialNamberPopUp";
import Toolbar, { Item } from "devextreme-react/toolbar";
import { Button } from "devextreme-react/button";

const InventorySubLot = (props) => {
  const history = useHistory();
  const location = useLocation();
  var accessToken = props.oidc.user.access_token;
  const [stateLocPopUp, setstateLocPopUp] = useState(false);
  const [stateStatusPopUp, setStateStatusPopUp] = useState(false);
  const [stateSerialNumberPopUp, setstateSerialNumberPopUp] = useState(false);
  const [statusbtnDisable, setStatusbtnDisable] = useState(true);
  const [SerialNumberBtnDisable, setSerialNumberBtnDisable] = useState(true);
  const [locbtnDisable, setlocbtnDisable] = useState(true);
  const [stateItemObj, setStateItemObj] = useState({});
  const [inventorySubLotCodesData, setinventorySubLotCodesData] = useState([]);
  const [inventoryItemCodeObj, setInventoryItemCodeObj] = useState({
    ItemCode: '',
    "Description-1": '',
    "Description-2": '',
    Status: '',
    Class: '',
    SubClass: '',
    itemRowid: location?.state?.detailItemRowid,
  });
  const [inventorySubLotCodesObj, setinventorySubLotCodesObj] = useState({
    lotRowid: location?.state?.detailLotRowid,
    itemRowid: location?.state?.detailItemRowid,
  });
  const {
    lotRowid,
    itemRowid
  } = inventorySubLotCodesObj;
  const handleCallback = (ChildData) => {
    axios
      .post(`${window._env_.REACT_APP_APIS}/${data.Item.GetItemByRowid}`, { itemRowid: ChildData.itemRowid },
        {
          headers: {
            "Content-Type": "application/json",
            access_token: accessToken,
            Authorization: `Bearer ${accessToken}`,
          },
        })
      .then((res) => {
        const updatedResData = {
          ...res.data,
          subLotRowid: ChildData.subLotRowid,
        };
        setStateItemObj(updatedResData);
      });
  };
  const handlEnableDisableLocBtn = (ChildData) => {
    setlocbtnDisable(ChildData);
  };
  const handlEnableDisableStatusBtn = (ChildData) => {
    setStatusbtnDisable(ChildData);
  };

  const handlEnableDisableSerialNumberBtn = (ChildData) => {
    setSerialNumberBtnDisable(ChildData);
  };
  const handleClosePopUpCallback = (ChildData) => {
    setstateLocPopUp(ChildData);
  };
  const handleStatusPopUpCloseCallback = (ChildData) => {
    setStateStatusPopUp(ChildData);
  };
  const handleSerialNumberClosePopUpCallback = (ChildData) => {
    setstateSerialNumberPopUp(ChildData);
  };
  const openLocations = (e) => {
    e.preventDefault();
    if (stateItemObj) {
      setstateLocPopUp(true);
    }
  };
  const openSerialnumberPopUp = (e) => {
    e.preventDefault();
    if (stateItemObj) {
      setstateSerialNumberPopUp(true);
    }
  };
  const openStatus = (e) => {
    e.preventDefault();
    if (stateItemObj) {
      setStateStatusPopUp(true);
    }
  };
  const loadInventorySubLotData = () => {
    axios
      .get(`${window._env_.REACT_APP_APIS}/${data.SubLot.GetAllSubLots}?itemRowid=` + inventorySubLotCodesObj.itemRowid + "&lotRowid=" + inventorySubLotCodesObj.lotRowid,
        {
          headers: {
            "Content-Type": "application/json",
            access_token: accessToken,
            Authorization: `Bearer ${accessToken}`,
          },
        })
      .then((res) => {
        setinventorySubLotCodesData(res.data.data);
      });
  };

  const Back = () => {
    history.push({
      pathname: '/wm/inventory-items'
    });
    return;
  };

  const onItemClick = (e) => {
    switch (e.itemData.name) {
      case 'Lots':
        history.push({
          pathname: '/wm/inventory-lots',
          state: { detail: inventoryItemCodeObj.itemRowid }
        });
        return;
      case 'Item':
        history.push({
          pathname: '/wm/inventory-items'
        });
        return;
      default:
        return;
    }
  }

  useEffect(() => {
    loadItemData();
    loadInventorySubLotData();
  }, []);
  const loadItemData = () => {
    axios
      .post(`${window._env_.REACT_APP_APIS}/${data.Item.GetItemByRowid}`, inventoryItemCodeObj,
        {
          headers: {
            "Content-Type": "application/json",
            access_token: accessToken,
            Authorization: `Bearer ${accessToken}`,
          },
        })
      .then((res) => {
        setInventoryItemCodeObj(res.data);
      });
  };

  return (
    <div className="container-fluid bg-white">
      {/* Toolbar Section */}
      <div className="row mb-2">
        <div className="col-md-12">
          <Toolbar>
            <Item location="before">
              <div className="title">
                <h6 style={{ color: window._env_.Color2 }}>
                  Inventory Sub Lot
                </h6>
              </div>
            </Item>
            <Item location="after">
              <Button onClick={Back} text="Back" icon="back" />
            </Item>
          </Toolbar>
        </div>
      </div>
  
      {/* Item Record Section */}
      <div className="row mb-3">
        <div className="col-md-12">
          <InventoryItemRecord itemObj={inventoryItemCodeObj} />
        </div>
      </div>
  
      {/* Grid Section */}
      <div className="row">
        <div className="col-md-12">
          <InventorySubLotGrid
            data={inventorySubLotCodesData}
            accessToken={accessToken}
            parentCallback={handleCallback}
            enableDisableLocBtn={handlEnableDisableLocBtn}
            enableDisableSrlNumber={handlEnableDisableSerialNumberBtn}
            enableDisableStatusBtn={handlEnableDisableStatusBtn}
            locbtnDisable={locbtnDisable}
            openLocations={openLocations}
            SerialNumberBtnDisable={SerialNumberBtnDisable}
            openSerialnumberPopUp={openSerialnumberPopUp}
            statusbtnDisable={statusbtnDisable}
            openStatus={openStatus}
          />
        </div>
      </div>
  
      {/* Popups */}
      {stateLocPopUp && (
        <LocationsPopUp
          itemObj={stateItemObj}
          visibility={stateLocPopUp}
          parentCallback={handleClosePopUpCallback}
        />
      )}
  
      {stateSerialNumberPopUp && (
        <InventorySerialNamberPopUp
          itemObj={stateItemObj}
          visibility={stateSerialNumberPopUp}
          parentCallback={handleSerialNumberClosePopUpCallback}
        />
      )}
  
      {stateStatusPopUp && (
        <InventoryItemStatusPopUp
          itemObj={stateItemObj}
          visibility={stateStatusPopUp}
          parentCallback={handleStatusPopUpCloseCallback}
        />
      )}
    </div>
  );
  
};
function mapStateToProps(state) {
  return {
    ReceiptReducer: state.ReceiptReducer,
    oidc: state.oidc,
  };
}
export default connect(mapStateToProps)(InventorySubLot);